module.exports = __webpack_public_path__ + "static/documentation-4e625328a19a74772a94459ddbf2ef63.gif";